var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const ForkKnife = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M4 3.08398V7.54598V7.63598V7.54598C4 8.81998 4.525 9.94798 5.339 10.678C5.737 11.035 6 11.517 6 12.052V19.5C6 20.328 6.672 21 7.5 21C8.328 21 9 20.328 9 19.5V12.052C9 11.517 9.263 11.035 9.661 10.678C10.475 9.94798 11 8.81998 11 7.54598V3.08398V7.54598M7.5 8V3M19.5 4.052C19.5 3.5 19.052 3.052 18.5 3.052H17.5C15.843 3.052 14.5 4.395 14.5 6.052V12.052C14.5 13.356 15.337 14.455 16.5 14.868V19.5C16.5 20.328 17.172 21 18 21C18.828 21 19.5 20.328 19.5 19.5V15.052V4.052Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
